import React, { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import {  useSelector } from "react-redux";
import { RootState } from "./store/type";
import ProtectedRouteUser from "./app/ProtectedRouteUser";
import ProtectedRoute from "./app/ProtectedRoute";
import LayoutHeader from "./layouts/layoutHeader";
import {
  AboutComingSoonPage,
  AboutUsPage,
  ArticlesList,
  ArticlesPage,
  ChangePasswordPage,
  CheckoutComponent,
  CompanyPage,
  ConfirmPage,
  CreateCompanyPage,
  ForgotPasswordPage,
  LandingPage,
  LandingPageBuyer,
  LandingPageSeller,
  LandingPaymentBuyer,
  LandingpaymentSeller,
  LoginPage,
  OrderPage,
  ProfilePage,
  QuatationTendersPage,
  RegisterPage,
  ResetPasswordPage,
  SellerOrder,
  SendOffert,
  SettingsPage,
  TenderCardPage,
  TenderMinePage,
  TenderPage,
  TendersPage,
  TenderSquarePage,
  PayLate,
  TenderTablePage,
  BuyerOrder,
} from "./pages";
import { routes } from "./consts";
import { ROLE } from "./types";
import { useLocale } from "./middleware";
import NotFoundPage from "./pages/not-found";

// Define route configuration types
interface RouteConfig {
  path: string;
  element: (props: RouteProps) => JSX.Element | null;
  protected: boolean;
  useProtectedUser?: boolean;
}

interface RouteProps {
  userRole: string;
  authUser: any;
}
const LandingPageSellerOrBuyer: React.FC<{ isSeller: boolean }> = ({
  isSeller,
}) => (isSeller ? <LandingPageSeller /> : <LandingPageBuyer />);

// Define route configurations

function App() {
  // const dispatch = useDispatch();
  const [openSideBar, setOpenSideBar] = useState<boolean>(true);
  const authUser = useSelector((state: RootState) => state.auth.authUser);
  const userRole: string = authUser?.role ?? "";
  // const { getMe } = useLogin();
  // const { getcategories } = useOffer();
  const { locale } = useLocale();
  const isSeller: boolean = userRole === ROLE.SELLER;
  const isBuyer: boolean = userRole === ROLE.BUYER;
  const routeConfig: RouteConfig[] = [
    {
      path: routes.home,
      element: () =>
        isBuyer || isSeller ? (
          <LandingPageSellerOrBuyer isSeller={isSeller} />
        ) : (
          <LandingPage />
        ),
      protected: isBuyer || isSeller,
    },
    {
      path: routes.payment,
      element: ({ userRole }) =>
        userRole === ROLE.BUYER ? (
          <LandingPaymentBuyer />
        ) : (
          <LandingpaymentSeller />
        ),
      protected: true,
    },
    {
      path: routes.register,
      element: () => <RegisterPage />,
      protected: false,
    },

    { path: routes.login, element: () => <LoginPage />, protected: false },
    {
      path: routes.forgetPassword,
      element: () => <ForgotPasswordPage />,
      protected: false,
    },
    {
      path: routes.changePassword,
      element: () => <ChangePasswordPage />,
      protected: false,
    },
    { path: routes.confirm, element: () => <ConfirmPage />, protected: false },
    {
      path: routes.resetPassword,
      element: () => <ResetPasswordPage />,
      protected: false,
    },
    {
      path: routes.payLater,
      element: () => <PayLate />,
      protected: false,
    },
    { path: routes.aboutUs, element: () => <AboutUsPage />, protected: false },
    { path: routes.settings, element: () => <SettingsPage />, protected: true },
    { path: routes.company, element: () => <CompanyPage />, protected: true },
    {
      path: routes.createCompany,
      element: () => <CreateCompanyPage />,
      protected: true,
      useProtectedUser: true,
    },
    {
      path: `${routes.quatation}/:id`,
      element: () => <SendOffert />,
      protected: true,
    },
    {
      path: `${routes.profile}/:id`,
      element: () => <ProfilePage />,
      protected: true,
    },
    {
      path: routes.createTender,
      element: () => <TenderPage />,
      protected: true,
    },
    {
      path: routes.tender,
      element: () => <TenderTablePage />,
      protected: true,
    },
    {
      path: routes.info,
      element: () => <AboutComingSoonPage />,
      protected: true,
    },
    {
      path: routes.quatationtenders,
      element: () => <QuatationTendersPage />,
      protected: true,
    },
    {
      path: routes.tenderSquatenders,
      element: () => <TenderSquarePage />,
      protected: true,
    },
    {
      path: routes.tenders,
      element: () =>
        isBuyer || isSeller ? (
          <>
            {isBuyer && (
              <LayoutHeader
                toggleOpenSideBar={toggleOpenSideBar}
                openSideBar={openSideBar}
              >
                <TenderMinePage />
              </LayoutHeader>
            )}
            {isSeller && (
              <LayoutHeader
                toggleOpenSideBar={toggleOpenSideBar}
                openSideBar={openSideBar}
              >
                {" "}
                <TendersPage isLog />
              </LayoutHeader>
            )}
          </>
        ) : (
          <TendersPage isLog={false} />
        ),
      protected: false,
    },
    {
      path: routes.orders,
      element: ({ userRole }) =>
        userRole === ROLE.BUYER ? <BuyerOrder /> : <SellerOrder />,
      protected: true,
    },
    {
      path: routes.checkout,
      element: ({ userRole }) =>
        userRole === ROLE.BUYER ? <CheckoutComponent /> : null,
      protected: true,
    },
    {
      path: `${routes.vuetender}/:id`,
      element: ({ authUser }) =>
        authUser ? <TenderCardPage /> : <TenderCardPage isShown />,
      protected: authUser,
    },
    {
      path: routes.articles,
      element: ({ userRole }) =>
        userRole === ROLE.SELLER ? <ArticlesList /> : null,
      protected: true,
    },
    {
      path: `${routes.items}/:id`,
      element: ({ userRole }) =>
        userRole === ROLE.SELLER ? <ArticlesPage /> : null,
      protected: true,
    },
    {
      path: `${routes.order}/:id`,
      element: () => <OrderPage />,
      protected: true,
    },
    {
      path: "*",
      element: () => <NotFoundPage />,
      protected: false,
    },
  ];

  const toggleOpenSideBar = (): void => setOpenSideBar((prev) => !prev);

  useEffect(() => {
    // const checkCurrent = async (): Promise<void> => {
    //   try {
    //     const response = await getMe();
    //     if (response.isSuccess) {
    //       storeData("tokens", response.data.tokens);
    //       storeData("userInfo", response.data.user);
    //       getcategories();
    //     }
    //   } catch (error) {
    //     dispatch(getMyCompany(null));
    //   }
    // };
    // checkCurrent();
  }, []);

  return (
    <Routes>
      {routeConfig.map((route) => {
        return (
          <Route
            key={route.path}
            path={`/${locale}${route.path}`}
            element={
              route.protected ? (
                route.useProtectedUser ? (
                  <ProtectedRouteUser>
                    <LayoutHeader
                      toggleOpenSideBar={toggleOpenSideBar}
                      openSideBar={openSideBar}
                    >
                      {route.element({
                        userRole,
                        authUser,
                      })}
                    </LayoutHeader>
                  </ProtectedRouteUser>
                ) : (
                  <ProtectedRoute>
                    <LayoutHeader
                      toggleOpenSideBar={toggleOpenSideBar}
                      openSideBar={openSideBar}
                    >
                      {route.element({
                        userRole,
                        authUser,
                      })}
                    </LayoutHeader>
                  </ProtectedRoute>
                )
              ) : (
                
                route.element({
                  userRole,
                  authUser,
                })
              )
            }
          />
        );
      })}
    </Routes>
  );
}

export default App;
